import {useState} from "react";
import {useQuery} from "react-query";
import axios from "services/axios";

async function getDoctorType(id, filter) {
	const {data} = await axios.get(`/misc/doctor-type`, {params: filter});

	return data;
}

export function useDoctorType() {
	const [filter, filterRelations] = useState({
		page: 1,
		search: null,
		limit: 10,
	});
	const [relationId, relationById] = useState(null);
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["doctorType", relationId, filter], async () => getDoctorType(relationId, filter));

	return {data, isLoading, isError, error, filter, filterRelations, relationById};
}
